import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubmitButton from '../../../components/form/formComponents/SubmitButton';
import MODES from '../../../components/form/onSubmitModes';
import ProfileStatus from './../../../utils/ProfileStatus';
import i18n from '../../../../shared/locales/no.json';

class EditProfileStatus extends Component {
    static propTypes = {
        onRequestPublish: PropTypes.func.isRequired,
        onRequestUnpublish: PropTypes.func.isRequired,
        profileId: PropTypes.number.isRequired,
        status: PropTypes.string.isRequired,
        isSaving: PropTypes.bool,
    };

    onRequestPublish() {
        this.props.onRequestPublish(this.props.profileId);
    }

    onRequestUnpublish() {
        this.props.onRequestUnpublish(this.props.profileId);
    }

    renderPublishButton(status) {
        switch (status) {
            case ProfileStatus.INACTIVE:
                return (
                    <SubmitButton
                        className="button--cta u-ml8"
                        mode={this.props.isSaving ? MODES.SAVING : MODES.EDIT}
                        onClick={this.onRequestPublish.bind(this)}
                        type="button"
                        value={i18n['Request Publish']}
                    />
                );
            case ProfileStatus.PENDING:
                return (
                    <button
                        className="button button--is-disabled u-ml8"
                        disabled
                        title={i18n['Awaiting approval']}
                    >
                        {i18n['Waiting for approval']}
                    </button>
                );
            case ProfileStatus.ACTIVE:
                return (
                    <SubmitButton
                        className="button--cta u-ml8"
                        mode={this.props.isSaving ? MODES.SAVING : MODES.EDIT}
                        onClick={this.onRequestUnpublish.bind(this)}
                        type="button"
                        value={i18n.Unpublish}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const { status } = this.props;

        return this.renderPublishButton(status);
    }
}

export default EditProfileStatus;
